import { useSelector } from "react-redux";
import { RootState } from "../../configureStore";
import { IInstitution } from "../../redux/reducer/institution";
import { useMemo } from "react";
import Table, { ColumnsType } from "antd/es/table";
import { Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

interface InstitutionsTableParams {
    onEdit: (_?: string) => void;
}

const InstitutionsTable = ({
    onEdit,
}: InstitutionsTableParams) => {
    const navigate = useNavigate();
    const institutions = useSelector<RootState, IInstitution[]>(({ institution }) => institution.institutions);
    const columns = useMemo<ColumnsType<IInstitution>>(() => [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'URL',
            dataIndex: 'host',
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            render: (id) => (
                <Dropdown
                    menu={{
                        items: [
                            {
                                key: `${id}_edit`,
                                label: 'Edit',
                                onClick: () => { onEdit(id); },
                            },
                            {
                                key: `${id}_customize`,
                                label: 'Customize',
                                onClick: () => { navigate(`/institution/${id}`); },
                            }
                        ]
                    }}
                    trigger={['click']}
                >
                    <MoreOutlined style={{ cursor: 'pointer' }} />
                </Dropdown>
            )
        }
    ], [institutions]);

    return (
        <Table
            columns={columns}
            dataSource={institutions}
            rowKey='id'
        />
    );
};

export default InstitutionsTable;
